import React from 'react'
import { Tab as ChakraTab } from '@chakra-ui/react'
import { As, HubStyleObject, forwardRef } from '@hub/design-system-base'

interface TabProps {
  sx?: HubStyleObject
  as?: As
  _selected: HubStyleObject
}

export const Tab = forwardRef<TabProps, typeof ChakraTab>(
  ({ sx, as, _selected, children }, ref) => (
    <ChakraTab ref={ref} sx={sx} as={as} _selected={_selected}>
      {children}
    </ChakraTab>
  )
)
